import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _toConsumableArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import api from '@/boot/api';
/**
 * Queries the api directly.
 *
 * @param {Object} payload Deferred
 *
 * @returns {Object}
 */

function queryApi(_x) {
  return _queryApi.apply(this, arguments);
}
/**
 * Queries an abstracted source of menu data
 *
 * @param {Object} payload Menu query payload
 *
 * @returns {Object}
 */


function _queryApi() {
  _queryApi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(payload) {
    var __paginateThroughAllData;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            __paginateThroughAllData = payload.__paginateThroughAllData || false;
            delete payload.__paginateThroughAllData;

            if (!__paginateThroughAllData) {
              _context8.next = 8;
              break;
            }

            _context8.next = 5;
            return Menu.paginateThroughAllData( /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(payload) {
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return api.queryMenuData(payload);

                      case 2:
                        return _context7.abrupt("return", _context7.sent);

                      case 3:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              }));

              return function (_x10) {
                return _ref.apply(this, arguments);
              };
            }(), payload);

          case 5:
            _context8.t0 = _context8.sent;
            _context8.next = 11;
            break;

          case 8:
            _context8.next = 10;
            return api.queryMenuData(payload);

          case 10:
            _context8.t0 = _context8.sent;

          case 11:
            return _context8.abrupt("return", _context8.t0);

          case 12:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _queryApi.apply(this, arguments);
}

function query(_x2) {
  return _query.apply(this, arguments);
}

function _query() {
  _query = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(payload) {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!(payload.edge === 'products' && payload.__paginateThroughAllData)) {
              _context9.next = 2;
              break;
            }

            throw new Error('Logic Error: Product querying requires end-user pagination');

          case 2:
            _context9.next = 4;
            return queryApi(payload);

          case 4:
            return _context9.abrupt("return", _context9.sent);

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _query.apply(this, arguments);
}

var Menu = {
  /**
   * All of the following functions allow for querying an abstracted source of menu data - be it the live api for the web, or the local store for the app. This should be used instead of direct api/store usage to simplify client code (after all, things like the Menu Insight question or whatever else should work in the same way in either case).
   *
   * @param {Object} payload Menu query payload
   * @param {Number} payload.offset The 0-based offset into the data for the provided edge
   * @param {String} payload.text A text filter to be applied to the edge
   * @param {String} payload.textFields If a text filter is provided, the fields to apply the text filter to on the edge.
   * @param {Array} payload.order The ordering of the data for the edge
   * @param {String} payload.type An internal product type id to filter by
   * @param {String} payload.familyGroupRef A family group epos id to filter by
   * @param {String} payload.majorGroupRef A major group epos id to filter by
   * @param {Array} payload.transactionProductRefs In the case of a transaction having been retrieved, an Array of non-modifier, non-free product epos ids as strings retrieved
   *
   * @returns {Object}
   */

  /**
   * Queries family groups, with common defaults on payload options
   *
   * @param {Object} payload Menu query payload, deferred to the above
   *
   * @returns {Object}
   */
  getFamilyGroups: function () {
    var _getFamilyGroups = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return query(_objectSpread({
                edge: 'family_groups',
                order: ['weight.desc', 'name'],
                textFields: ['name'],
                __paginateThroughAllData: true
              }, payload));

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getFamilyGroups(_x3) {
      return _getFamilyGroups.apply(this, arguments);
    }

    return getFamilyGroups;
  }(),

  /**
   * Paginate through all data for a generic api endpoint. This will work for any FIB api call by construction, but should only be used on api calls where the predicted amount of data to receive is anticipated to be not too large. E.g. For menu products or branches, don't use this -- you should only paginate based on user requirements - don't fetch all products at once, paginate as the user scrolls through the data.
   *
   * @param {Function} call Async api call
   * @param {Object} payload The payload for the api call
   *
   * @returns {Object}
   */
  paginateThroughAllData: function () {
    var _paginateThroughAllData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(call, payload) {
      var offset, size, limit, result, _response$items, response;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              offset = 0;
              size = 0; // Use the defined limit, or 100 as a default

              limit = payload.limit || 100;
              result = [];

            case 4:
              _context2.next = 6;
              return call(_objectSpread(_objectSpread({}, payload), {}, {
                offset: offset,
                limit: limit
              }));

            case 6:
              response = _context2.sent;

              if (!(response || {}).error) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", response);

            case 9:
              // We'll be careful about response being passed back as falsy by using ?. for a little while..
              // Capture what the size of the packet is.
              size = (response === null || response === void 0 ? void 0 : (_response$items = response.items) === null || _response$items === void 0 ? void 0 : _response$items.length) || 0;
              offset += size; // Add on to previous results.

              result = [].concat(_toConsumableArray(result), _toConsumableArray((response === null || response === void 0 ? void 0 : response.items) || []));

            case 12:
              if (size >= limit) {
                _context2.next = 4;
                break;
              }

            case 13:
              return _context2.abrupt("return", result);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function paginateThroughAllData(_x4, _x5) {
      return _paginateThroughAllData.apply(this, arguments);
    }

    return paginateThroughAllData;
  }(),

  /**
   * Queries major groups, with common defaults on payload options
   *
   * @param {Object} payload Menu query payload, deferred to the above
   *
   * @returns {Object}
   */
  getMajorGroups: function () {
    var _getMajorGroups = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return query(_objectSpread({
                edge: 'major_groups',
                order: ['name'],
                textFields: ['name'],
                __paginateThroughAllData: true
              }, payload));

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function getMajorGroups(_x6) {
      return _getMajorGroups.apply(this, arguments);
    }

    return getMajorGroups;
  }(),

  /**
   * Queries products, with common defaults on payload options
   *
   * @param {Object} payload Menu query payload, deferred to the above
   *
   * @returns {Object}
   */
  getProducts: function () {
    var _getProducts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return query(_objectSpread({
                edge: 'products',
                order: ['major_group_ref', 'name'],
                textFields: ['major_group_name', 'name']
              }, payload));

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function getProducts(_x7) {
      return _getProducts.apply(this, arguments);
    }

    return getProducts;
  }(),

  /**
   * Helper query to determine if any products exist for the given payload.
   * Implemented separately from the full fetch so we can optimise this use case.
   *
   * @param {Object} payload Menu query payload, deferred to the above
   *
   * @returns {Boolean}
   */
  productsExist: function () {
    var _productsExist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
      var _products$items;

      var products;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return Menu.getProducts(_objectSpread(_objectSpread({}, payload), {}, {
                offset: 0,
                limit: 1
              }));

            case 2:
              products = _context5.sent;
              return _context5.abrupt("return", (products === null || products === void 0 ? void 0 : (_products$items = products.items) === null || _products$items === void 0 ? void 0 : _products$items.length) > 0);

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function productsExist(_x8) {
      return _productsExist.apply(this, arguments);
    }

    return productsExist;
  }(),

  /**
   * Helper query to determine if any family groups exist for the given payload.
   * Implemented separately from the full fetch so we can optimise this use case.
   *
   * @param {Object} payload Menu query payload, deferred to the above
   *
   * @returns {Boolean}
   */
  familyGroupsExist: function () {
    var _familyGroupsExist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload) {
      var _familyGroups$items;

      var familyGroups;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return Menu.getFamilyGroups(_objectSpread(_objectSpread({}, payload), {}, {
                __paginateThroughAllData: false,
                // Don't force everything to be loaded, we just need 1 item :)
                offset: 0,
                limit: 1
              }));

            case 2:
              familyGroups = _context6.sent;
              return _context6.abrupt("return", (familyGroups === null || familyGroups === void 0 ? void 0 : (_familyGroups$items = familyGroups.items) === null || _familyGroups$items === void 0 ? void 0 : _familyGroups$items.length) > 0);

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function familyGroupsExist(_x9) {
      return _familyGroupsExist.apply(this, arguments);
    }

    return familyGroupsExist;
  }()
};
export default Menu;